import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { Anleitungsdokument } from '../../domain/model/anleitung';
import { AuthenticationService } from '../../service/auth/authentication.service';
import { UflaUser } from '../../service/auth/ufla-user';
import { ActivatedRoute } from '@angular/router';

import { OrganisationsTyp } from '../../domain/model/organisationsTyp';
import { NeueAnleitung } from '../../domain/model/neueanleitung';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'ufla-anleitungen-upload',
    templateUrl: './anleitungen-upload.component.html',
    styleUrls: [
        './anleitungen-upload.component.scss',
    ],
    standalone: false,
})
export class AnleitungenUploadComponent {
    private authenticationService = inject(AuthenticationService);
    private route = inject(ActivatedRoute);
  @Input() anleitungsdokument: Anleitungsdokument;

  @Input() uflaUser: UflaUser;

  @Output() fileChange = new EventEmitter<NeueAnleitung>();

  @Output() downloadTrigger = new EventEmitter<OrganisationsTyp>();

  @Output() deleteFileTrigger = new EventEmitter<OrganisationsTyp>();

  public selectedFileControl = new FormControl();
  public fileValidatorOptions = { maxFileSizeBytes: 150 * 1024 * 1024 };

  constructor() {
      this.uflaUser = this.route.snapshot.data.profile;
  }

  isAdmin(): boolean {
      return this.authenticationService.isAdmin(this.uflaUser);
  }

  public isFileSizeError(): boolean {
      return this.selectedFileControl.hasError('maxFileSize');
  }

  public isFilePresent(): boolean {
      return !this.selectedFileControl.invalid && this.selectedFileControl.value?.[0];
  }

  uploadAnleitung() {
      const neueAnleitung: NeueAnleitung = {
          organisationsTyp: this.anleitungsdokument.organisationsTyp,
          file: this.selectedFileControl.value[0],
      };
      this.fileChange.emit(neueAnleitung);
  }

  downloadFile(organisationsTyp: OrganisationsTyp) {
      this.downloadTrigger.emit(organisationsTyp);
  }

  deleteAnleitungByRole(organisationsTyp: OrganisationsTyp) {
      this.deleteFileTrigger.emit(organisationsTyp);
  }
}
